import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SheetSlotComponentBase } from 'src/app/services/sheets-renderer.service';
import { IvtfSupplementationActionV2 } from 'src/app/types/sheet-action-aggregate-graph.types';
import { TickValueComponent } from '../../tick-value/tick-value.component';

@Component({
    selector: 'app-ivtf-supplementation-slot-v2',
    templateUrl: './ivtf-supplementation-slot-v2.component.html',
    styleUrl: './ivtf-supplementation-slot-v2.component.scss',
    imports: [TickValueComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IvtfSupplementationSlotComponentV2 implements SheetSlotComponentBase {

	action!: IvtfSupplementationActionV2;
	value!: string | null;

	@Input('action') set updateAction(action: IvtfSupplementationActionV2 | null) {
		this.action = action as IvtfSupplementationActionV2;
		this.value = this.action.rate?.quantity?.toString() ?? null;
	}

	constructor() {
	}
}